import { Heading, Paragraph } from "../../../atoms";
import { Flex } from "../../../cores";
import { IconGoodChooice } from "../../../icons";

interface ISafestChoiceDescription {
  heading: string;
  paragraph: string;
  isMobile: boolean;
  noMarginRight?: boolean;
  noPaddingLeft?: boolean;
}
const SafestChoiceDescription = ({
  heading,
  paragraph,
  isMobile,
  noMarginRight = false,
}: ISafestChoiceDescription) => {
  return (
    <>
      <Heading as={"h4"} variant={!isMobile ? "h5" : "h6"}>
        {heading}
      </Heading>
      <Flex
        sx={{
          flexDirection: ["column", null, "row", null, null],
          ">span:first-of-type": {
            marginBottom: [5, null, "auto", null, null],
          },
        }}
      >
        <IconGoodChooice />
        <Paragraph
          sx={{
            marginRight: noMarginRight
              ? "0 !important"
              : [null, null, null, "30%", null],
            marginLeft: [null, null, "sm"],
            fontSize: ["xs", null, "16px", null, null],
          }}
        >
          {paragraph}
        </Paragraph>
      </Flex>
    </>
  );
};

export default SafestChoiceDescription;
